import React, { useState } from 'react';
import { CommonContainer, TableContainer } from '../../common/Container';
import TabMenu from '../TabMenu';
import styled from 'styled-components';
import { BsFillExclamationCircleFill } from 'react-icons/bs';
import Button from '../../common/Button';
import ActionTable from '../../common/ActionTable';
import Loading from '../../common/Loading';
import palette from '../../../lib/styles/palette';
import { sortReverse } from '../../../lib/commonFunc/commonFunc';
import CoachMenuSettingModal from './CoachMenuSettingModal';

const ButtonCollectionBlock = styled.div`
  float: right;
  padding: 1rem;

  & > button {
    margin-left: 10px;
  }
`;

const HeaderCell = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;

  .tooltip-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .tooltip-icon {
    display: inline-flex;
    align-items: center;
    color: ${palette.webGray[6]};
    cursor: help;
    font-size: 0.9rem;
  }

  .tooltip-box {
    display: none;
    position: absolute;
    top: 150%;
    left: 50%;
    transform: translateX(-50%);
    width: 322px;
    padding: 12px 14px;
    background-color: #fff;
    border: 1px solid ${palette.webGray[5]};
    border-radius: 0.3rem;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.12);
    font-size: 0.83rem;
    font-weight: normal;
    line-height: 1.6;
    color: ${palette.webGray[13]};
    text-align: left;
    white-space: normal;
    word-break: keep-all;
    z-index: 30;
  }

  .tooltip-box::before,
  .tooltip-box::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    width: 0;
    height: 0;
    border-style: solid;
    border-color: transparent;
  }

  /* gray backing triangle (matches the box border) */
  .tooltip-box::before {
    margin-left: -7px;
    border-width: 7px;
    border-bottom-color: ${palette.webGray[5]};
  }

  /* white fill triangle on top, leaving a 1px gray outline */
  .tooltip-box::after {
    margin-left: -6px;
    border-width: 6px;
    border-bottom-color: #fff;
  }

  .tooltip-wrap:hover .tooltip-box {
    display: block;
  }
`;

const HeaderTooltip = ({ label, description }) => (
  <HeaderCell>
    <span>{label}</span>
    <span className="tooltip-wrap">
      <BsFillExclamationCircleFill className="tooltip-icon" />
      <span className="tooltip-box">{description}</span>
    </span>
  </HeaderCell>
);

const CoachConfig = ({ coach, club, onChangeWebPermission, onChangeNotification, onSaveMenuSetting, onModify, onDelete, onRegist, loading }) => {
  const [menuModalCoach, setMenuModalCoach] = useState(null);

  if (loading)
    return (
      <>
        <TabMenu underbar />
        <ButtonCollectionBlock>
          <Button onClick={onRegist} cyan>
            강사 등록
          </Button>
        </ButtonCollectionBlock>
        <Loading />
      </>
    );
  return (
    <>
      <TabMenu underbar />
      <ButtonCollectionBlock>
        <Button onClick={onRegist} cyan>
          강사 등록
        </Button>
      </ButtonCollectionBlock>
      <TableContainer>
        {coach ? (
          <ActionTable
            data={coach.infos && sortReverse(coach.infos, 'name')}
            th={[
              '이름',
              '연락처',
              '계정',
              <HeaderTooltip
                key="permission"
                label="CRM 접속권한"
                description={
                  <>
                    해당 강사에게 CRM에 접속할 수 있는 권한을 부여하는 기능입니다.
                    <br />
                    권한을 켜두면 강사가 CRM에 직접 접속하여 이용할 수 있어요.
                  </>
                }
              />,
              '메뉴 설정',
              <HeaderTooltip
                key="groupReservation"
                label="그룹수업 예약 알림"
                description={
                  <>
                    강사가 담당한 그룹수업에 회원이 예약을 하면, 해당 강사의 앱으로 예약
                    알림을 보내드리는 기능입니다.
                    <br />
                    켜두면 회원의 예약 소식을 앱에서 바로 확인할 수 있어요.
                  </>
                }
              />,
              <HeaderTooltip
                key="sales"
                label="매출 알림"
                description={
                  <>
                    매출이 발생하면 해당 강사의 앱으로 매출 알림을 보내드리는 기능입니다.
                    <br />
                    켜두면 새로운 매출 소식을 앱에서 바로 확인할 수 있어요.
                  </>
                }
              />,
              '액션',
            ]}
            renderingCol={['name', 'phone', 'account', 'permission', 'menuSetting', 'groupReservation', 'sales', 'actions']}
            btnAmount={2}
            onModify={onModify}
            onDelete={onDelete}
            onChangeWebPermission={onChangeWebPermission}
            onChangeNotification={onChangeNotification}
            onOpenMenuSetting={(item) => setMenuModalCoach(item)}
            text="강사"
          />
        ) : (
          <></>
        )}
      </TableContainer>
      {menuModalCoach && (
        <CoachMenuSettingModal
          coach={menuModalCoach}
          club={club}
          onClose={() => setMenuModalCoach(null)}
          onSave={(webMenuHidden) => {
            onSaveMenuSetting(menuModalCoach.playerID, webMenuHidden);
            setMenuModalCoach(null);
          }}
        />
      )}
    </>
  );
};

export default CoachConfig;
